import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { companyKeys } from "@/lib/query-keys";
import type { FollowedCompaniesState } from "@/types/domain";

const EMPTY: FollowedCompaniesState = { companies: [], activity: [], newAwardsThisWeek: 0 };

/** Las empresas que sigue el usuario, con lo último que ganaron. */
export function useFollowedCompanies(enabled = true) {
  const { data = EMPTY } = useQuery<FollowedCompaniesState>({
    queryKey: companyKeys.followed(),
    enabled,
    queryFn: () => fetchToBackend("/companies/followed"),
  });
  return {
    ...data,
    isFollowing: (companyId: number) =>
      data.companies.some((company) => company.companyId === companyId),
    newAwardsOf: (companyId: number) =>
      data.companies.find((company) => company.companyId === companyId)?.newAwards ?? 0,
  };
}
